/* ---------------------------------------------------------------------------
   The draw's clock, in one place.

   Two surfaces show it: the inline bar on the product page and the opt-in
   popup. They have to agree to the second. A bar reading "2 days" beside a
   popup reading "3 days" is not a rounding difference to a visitor, it is a
   reason to disbelieve both, so the arithmetic lives here rather than being
   written twice and drifting.

   WHY IT IS NOT DONE IN LIQUID

   Liquid has no timezone arithmetic and Pacific is UTC-7 for part of the year
   and UTC-8 for the rest, so a server-rendered countdown is an hour wrong for
   half of it. Shopify also caches section markup, so the answer would go stale
   between renders. Intl knows the offset on any given date; the browser decides.

   THE CYCLE

   Live from the opening (Monday 10:00 Pacific by default), counting down to the
   close (Sunday 12:00). Dark in between. The gap is deliberate: a clock sitting
   at zero is worse than no clock, and a dark window makes the announcement feel
   like an event rather than a rollover.
   --------------------------------------------------------------------------- */
window.wxSchedule = (function () {
  var DOW = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

  // The wall clock in a named zone, the only thing Intl reports directly.
  function parts(ms, tz) {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hour12: false, year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    f.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    if (p.hour === '24') p.hour = '00';        // Intl says 24 for midnight
    return p;
  }

  // Reading the zone's own clock and treating it as UTC gives the offset by
  // subtraction, correct across both daylight saving switches.
  function offset(ms, tz) {
    var p = parts(ms, tz);
    return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second)
           - Math.floor(ms / 1000) * 1000;
  }

  // A wall clock turned back into an instant. Two passes, because the first
  // offset is read at the wrong instant on a DST weekend.
  function instant(y, mo, d, h, mi, tz) {
    var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
    return guess - offset(guess - offset(guess, tz), tz);
  }

  // The first <dow> at <h:mi> strictly after now. Date arithmetic stays on the
  // calendar triple, never on a timestamp, so a 23 or 25 hour day cannot push
  // it onto the wrong date.
  function next(now, tz, dow, h, mi) {
    var p = parts(now, tz);
    for (var i = 0; i <= 7; i++) {
      var c = new Date(Date.UTC(+p.year, p.month - 1, +p.day) + i * 86400000);
      if (c.getUTCDay() !== dow) continue;
      var t = instant(c.getUTCFullYear(), c.getUTCMonth() + 1, c.getUTCDate(), h, mi, tz);
      if (t > now) return t;
    }
    return null;
  }

  function spec(str, fallbackDow) {
    var v = String(str || '').split(',');
    var hm = (v[1] || '00:00').split(':');
    var d = DOW[(v[0] || '').toLowerCase().slice(0, 3)];
    return { dow: d === undefined ? fallbackDow : d, h: +hm[0] || 0, mi: +hm[1] || 0 };
  }

  /**
   * state({tz, close:'sun,12:00', open:'mon,10:00', ends:<epoch seconds>})
   *   -> { over, live, target, left, parts:[dd,hh,mm,ss] }
   *
   * `over` means the campaign end date has passed and nothing should ever show
   * again. `live` means we are inside this week's window.
   */
  function state(cfg) {
    var tz = cfg.tz || 'America/Los_Angeles';
    var now = Date.now();
    if (cfg.ends && now >= cfg.ends * 1000) return { over: true, live: false };

    var close = spec(cfg.close, 0), open = spec(cfg.open, 1);
    var nextClose = next(now, tz, close.dow, close.h, close.mi);
    var nextOpen = next(now, tz, open.dow, open.h, open.mi);

    // If the next opening lands before the next close, we are in the gap
    // between an announcement and the following week.
    if (nextOpen !== null && nextOpen < nextClose) {
      return { over: false, live: false, target: nextOpen };
    }
    var left = Math.max(0, (nextClose - now) / 1000);
    return {
      over: false, live: true, target: nextClose, left: left,
      parts: [Math.floor(left / 86400), Math.floor(left / 3600) % 24,
              Math.floor(left / 60) % 60, Math.floor(left) % 60]
    };
  }

  /** Paints [data-u="0..3"] inside `root` and returns the state. */
  function paint(root, cfg) {
    var st = state(cfg);
    if (!st.live) return st;
    var out = root.querySelectorAll('[data-u]');
    for (var i = 0; i < out.length && i < 4; i++) {
      out[i].textContent = String(st.parts[i]).padStart(2, '0');
    }
    return st;
  }

  return { state: state, paint: paint };
})();
